import { Dots } from "@/components/carousel/Carousel.types";
import React from "react";
import { PdpCarousel } from "./PdpCarousel";
import { ThumbnailGallery } from "./ThumbnailGallery";

interface MediaGalleryProps {
  mode: "carousel" | "thumbnail";
  dots?: Dots | "none";
}

export const MediaGallery = ({ mode, dots }: MediaGalleryProps) => {
  return mode == "carousel" ? (
    <PdpCarousel dots={dots} />
  ) : (
    <ThumbnailGallery />
  );
};
